import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface SynchronizationInterface {
    sendOfflineData(triggerSyncEvent?: boolean): Observable<void>;
    receiveWhatsNew(triggerSyncEvent?: boolean): Observable<void>;
    receiveEverything(triggerSyncEvent?: boolean): Observable<void>;
}

export const SynchronizationInstanceToken = new InjectionToken<SynchronizationInterface>('SynchronizationInterface');
